import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@ngneat/transloco';
import { VersionCheckService } from 'app/core/version-check/version-check.service';

@Component({
  selector: 'app-version-banner',
  standalone: true,
  imports: [MatButtonModule, MatIconModule, TranslocoModule],
  template: `
    @if (versionCheck.outOfDate() && !versionCheck.dismissed()) {
      <div
        class="fixed top-0 right-0 left-0 z-[999] flex w-full flex-shrink-0 flex-col gap-2 bg-amber-500 px-4 py-3 text-sm font-medium text-white shadow-lg print:hidden sm:flex-row sm:items-center sm:justify-between sm:gap-4 sm:px-6 sm:py-2.5"
      >
        <div class="flex min-w-0 items-start gap-2 sm:items-center">
          <mat-icon
            class="mt-0.5 flex-shrink-0 !text-white sm:mt-0"
            svgIcon="heroicons_outline:exclamation-triangle"
          ></mat-icon>
          <span class="min-w-0 leading-snug">
            {{ 'version.outdated' | transloco }}
            <span class="hidden sm:inline">
              &nbsp;&mdash;&nbsp; {{ 'version.local' | transloco }}:
              <strong>{{ versionCheck.localVersion() }}</strong>
              &nbsp;&rsaquo;&nbsp;
              {{ 'version.remote' | transloco }}:
              <strong>{{ versionCheck.remoteVersion() }}</strong>
            </span>
            <span class="block text-xs text-white/80 sm:hidden">
              {{ versionCheck.localVersion() }} &rsaquo; {{ versionCheck.remoteVersion() }}
            </span>
          </span>
        </div>
        <div class="flex flex-shrink-0 items-center gap-1 self-end sm:self-auto">
          <button
            mat-button
            class="!text-white/80 hover:!text-white"
            (click)="versionCheck.dismiss()"
          >
            {{ 'version.later' | transloco }}
          </button>
          <button
            mat-flat-button
            class="!bg-white !font-semibold !text-amber-700"
            (click)="reload()"
          >
            {{ 'version.update-now' | transloco }}
          </button>
        </div>
      </div>
    }
  `,
})
export class VersionBannerComponent {
  readonly versionCheck = inject(VersionCheckService);

  reload(): void {
    window.location.reload();
  }
}
